module.exports = __webpack_public_path__ + "static/desktop-mast-cdb27242e25d26fc66ce9702d2adb99d.png";